import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { fetchEnv, isEnvironmentReady, setErroCode, setIsAuthorizedForRealmSetup, setIsLoaded, setIsRealmSetup, setSelectedTab, } from "../../store/reducers/appSlice";
import { fetchAccessToken, fetchUserInfo, isUserAuthenticated, } from "../../store/reducers/userSlice";
import { collectionHRN, getConfiguration, getDraftsList } from "../../api/app";
import { INDOOR_MAP } from "../../store/common/constants";
var useFetchMaps = function () {
    var dispatch = useDispatch();
    var token = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.token; });
    var environment = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.environment; });
    var isEnvReady = useSelector(isEnvironmentReady);
    var isAuthenticated = useSelector(isUserAuthenticated);
    var user = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.user.info; });
    var isRealmSetup = useSelector(function (state) { return state.app.isRealmSetup; });
    var venuesListData = useSelector(function (state) { return state.venues.initialVenuesList; });
    var isLoaded = useSelector(function (state) { return state === null || state === void 0 ? void 0 : state.app.isLoaded; });
    var scopedTokenPresent = useSelector(function (state) { return state.user.scopedTokenPresent; });
    var pathname = useLocation().pathname;
    // to keep internaltools page book marking
    useEffect(function () {
        if (pathname === "/internalTools") {
            dispatch(setSelectedTab("internalTools"));
        }
        //scroll on top when navigated
        window.scrollTo(0, 0);
    }, [dispatch, pathname]);
    useEffect(function () {
        // fetch environment related data sit, prod, dev
        dispatch(fetchEnv());
    }, [dispatch]);
    useEffect(function () {
        if (isEnvReady) {
            // once get the environment fetch user token by using environment specific api
            dispatch(fetchAccessToken());
        }
    }, [isEnvReady, dispatch]);
    useEffect(function () {
        if (isAuthenticated) {
            dispatch(fetchUserInfo(null));
        }
    }, [isAuthenticated, dispatch]);
    useEffect(function () {
        if (token && isRealmSetup && scopedTokenPresent) {
            dispatch(getDraftsList());
            dispatch(collectionHRN());
        }
        else if (scopedTokenPresent) {
            // this case is reached when realm is not setup and user has access to project
            dispatch(getConfiguration());
        }
    }, [
        dispatch,
        token,
        environment.environmentId,
        isRealmSetup,
        scopedTokenPresent,
    ]);
    useEffect(function () {
        var _a;
        if (!isRealmSetup && isLoaded) {
            // this case is reached when user does have realm setup
            var userIsAdmin = (_a = user === null || user === void 0 ? void 0 : user.roles) === null || _a === void 0 ? void 0 : _a.some(function (r) {
                return INDOOR_MAP.AUTHORIZED_ROLES.includes(r);
            });
            if (userIsAdmin) {
                // if user is admin but does not have realm setup
                dispatch(setIsAuthorizedForRealmSetup(true));
                dispatch(setErroCode(0));
            }
            else {
                // if user is not an admin and does not have realm setup
                dispatch(setErroCode(404));
            }
            dispatch(setIsRealmSetup(false));
            dispatch(setIsLoaded(true));
        }
    }, [dispatch, isRealmSetup, isLoaded, user === null || user === void 0 ? void 0 : user.roles]);
    return venuesListData;
};
export default useFetchMaps;
